import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { ClientsEppExportQuery, ClientsEppExportQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ClientsEppExportQuery)
@Wrapper(ClientsEppExportQueryHandlerBase)
export class ClientsEppExportQueryHandler {
    public constructor(
        http: Http
    ) { }
}
